import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetBagsCashReportReqData } from "./GetBagsCashReportReqData";

const ENDPOINT = "/cash_flow/bags_cash_report";

export class ExportBagsCashReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = null;

    constructor(params: GetBagsCashReportReqData, exportType: string) {
        super();
        this.params = { exportType, ...params };
        this.responseType = "text";
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.params);
    }
}
